import { routerStore } from "../../../../url/WSRouter";

export function getQuickApplyConnectRedirectUrl() {
  if (routerStore.hostUrl) {
    // iframe
    return routerStore.hostUrl
      .replace("cvpage=apply-manually", "cvpage=applicationsent")
      .replace("cvpage=apply", "cvpage=applicationsent");
  }

  return window.location.href
    .replace("/apply-manually", "/applicationsent")
    .replace("/apply", "/applicationsent");
}
